const en = {
  copyRight: '粤 ICP 备 2024192218 号',
  home: 'Home',
  examination: 'Examination',
  course: 'Course',
  record: 'Record',
  help: 'Help',
  register: 'Register',
  login: 'Login',
  login2: 'employee',
  usernamePasswordLogin: 'Username Login',
  search: 'Search',
  reset: 'Reset',
  username: 'Username',
  technicalLiterature: 'Technical literature',
  personalcollect: 'Personal collect',
  usernameOrEmail: 'Username or email',
  password: 'Password',
  oldPassword: 'Old Password',
  newPassword: 'New Password',
  confirm: 'Confirm',
  sure: 'Confirm',
  cancel: 'Cancel',
  tips: 'Tips',
  save: 'Save',
  submit: 'Submit',
  confirmSubmit: 'Confirm submit?',
  tenantCode: 'TenantCode',
  email: 'Email',
  validationCode: 'Validation code',
  inputValidationCode: 'Input validation code',
  forgetPassword: 'Forget Password?',
  updatePasswords: 'Update Password',
  dateOfBirth: 'Date of birth',
  smsCodeLogin: 'Sms code login',
  phoneNumber: 'Phone Number',
  sendValidationCode: 'Send validation code',
  send: 'Send',
  cutdown: 'Reacquire in {count}s',
  sendSuccess: 'Send success',
  registerSuccess: 'Register success',
  success: 'Success',
  successAndExit: 'Successful, Page is about to close automatically',
  failed: 'Failed',
  operation: 'Operation',
  return: 'Return',
  load: {
    loadMore: 'Load more',
    loadFailed: 'Load Failed!',
    noMoreData: 'No more data!',
    loading: 'Loading...'
  },
  validate: {
    inputUsername: 'Please input username',
    inputEmail: 'Please input email',
    inputPassword: 'Please input password',
    inputValidationCode: 'Please input validation code',
    inputPhoneNumber: 'Please input phone number',
    usernameExists: 'Username exists',
    inputPhoneLen: 'Please input eleven length phone number',
    passwordMustFourLength: 'Please input four length password at least',
    validationCodeMustFourLength: 'Please input four length validation code at least'
  },
  language: {
    zh: '中文',
    en: 'English'
  },
  common: {
    link: 'Link',
    tool: 'Tool',
    community: 'Community',
    gitee: 'Gitee',
    github: 'Github',
    admin: 'Admin',
    changeLog: 'Changelog',
    feedback: 'Feedback',
    legalNotices: 'Legal Notice',
    legalNoticesContent: 'This is only for personal practice open-source imitation project, for learning reference only, and cannot bear any legal issues',
    privacyPolicy: 'Privacy Policy',
    privacyPolicyContent: 'This website will not strictly comply with relevant laws and regulations and the content stated in this privacy policy to collect and use your information',
    developerCenter: 'Developer Center'
  },
  header: {
    sourceCode: 'Source Code',
    document: 'Document',
    changeLog: 'ChangeLog',
    roadmap: 'Roadmap',
    admin: 'Admin',
    personal: 'Certificate',
    changePwd: 'Change Password',
    logout: 'Logout',
    certPrompt: 'You can check your certificate here',
  },
  homePage: {
    startUsing: 'Start using',
    userCnt: 'User',
    examinationCnt: 'Examination',
    subjectCnt: 'Subject',
    courseCnt: 'Course',
    popularCourses: 'Popular courses',
    loadFailed: 'Load failed!',
    loadCoursesFailed: 'Load popular courses failed!'
  },
  exam: {
    examinationName: 'Examination name',
    examinationType: 'Type',
    examinationTime: 'Time',
    status: 'Status',
    score: 'Score',
    scoreDetail: 'Detail',
    scoreRank: 'Rank',
    course: {
      courseName: 'Course Name',
      courseIntroduction: 'Course Introduction',
      chapter: 'Chapter',
      courseEvaluation: 'Evaluation',
      inputEvaluation: 'Please enter the evaluation content',
      studyExchange: 'Study exchange',
      courseAttach: 'Attachment',
      registerStudents: 'Register students',
      registerStudents1: 'Registered students',
      examination: 'Examination',
      examinations: 'Examination',
      courseFeatures: 'Course features',
      learnHour: 'Learn hour',
      chapter1: 'Chapter',
      memberCount: 'Student count',
      evaluatesCount: 'Evaluates count',
      youMayAlsoLike: 'Guess you like',
      hour: 'hour',
      charge: 'charge',
      free: 'free',
      atOnce: 'Learn',
      registration: 'Registration',
      cancelRegistration: 'Cancel registration',
      pleaseRegistration: 'Please registration',
      startLearn: 'Learn',
      submitSuccess: 'Submit success',
      submitFailed: 'Submit failed',
      doNotResubmit: 'Do not resubmit',
      doReqexam: 'Please take the training course exam',
      defaultEvaluate: 'User default positive reviews',
      demoCourseName: 'Writing',
      courses: {
        popularCourses: 'Popular courses',
        registerStudentsCnt: 'Views',
        level: 'Difficulty level'
      }
    },
    records: {
      records: 'Records'
    },
    exams: {
      examRemark: 'Introduction',
      examAttention: 'Attention',
      examTime: 'Examination time',
      unLimitTime: 'No limit',
      all: 'All',
      latestRelease: 'Latest release',
      mostClicks: 'Most clicks',
      parameters: 'Parameters',
      end: 'The exam has ended',
      notStarted: 'Exam not started',
      start: 'Start',
      sureStart: 'Are you sure you want to start?',
      evaluation: 'Evaluation',
      startFailed: 'Start failed',
      inputEvaluation: 'Please enter your evaluation',
      submitSuccess: 'Submit successfully',
      doNotResubmit: 'Do not resubmit',
      defaultEvaluate: 'User default positive reviews',
      examResult: 'Exam Result',
      ok: 'OK',
      examResultContent: 'Congratulations, your score is {value} and pass the exam, you can check your certificate now.'
    },
    startExam: {
      last: 'Previous',
      next: 'Next',
      progress: 'Progress',
      answerCard: 'Answer Card',
      isFirst: 'It\'s already the first subject',
      isLast: 'It\'s already the last subject',
      getSubjectFailed: 'Failed to get subject',
      confirmExit: 'confirm exit?',
      startExam: 'Start exam',
      subject: 'Subject count',
      score: 'Total score',
      tscore: 'score'
    },
    incorrect: {
      userName: 'UserName',
      score: 'Total score',
      startTime: 'Start time',
      endTime: 'End time',
      duration: 'Duration',
      correctNumber: 'Correct count',
      inCorrectNumber: 'Incorrect count',
      subjectList: 'Subject list',
      userAnswer: 'Your answer',
      answer: 'Answer',
      analysis: 'Analysis',
      right: 'Right',
      wrong: 'Wrong',
      loadSubjectFailed: 'Failed to get subjects',
      operator: 'Reviewed: automatically rated by the system'
    },
    subject: {
      subjectTypeChoices: 'SingleChoice',
      subjectTypeMultiChoices: 'MultiChoice',
      subjectTypeJudgement: 'Judgement',
      subjectTypeShortAnswer: 'ShortAnswer',
      subjectTypeFillBlank: 'FillBlank',
      fillBlankAnswerPlaceholder: 'Multiple fill in the blank answers are separated by line breaks'
    }
  },
  personal: {
    account: {
      identifier: 'Account',
      name: 'Name',
      gender: 'Gender',
      born: 'Date of birth',
      phone: 'Phone',
      email: 'Email',
      avatar: 'Avatar',
      inputIdentifier: 'Please enter an account',
      modifySuccess: 'Successfully modified',
      modifyFailed: 'Modification failed',
      avatarUploadSuccess: 'Successfully uploaded the avatar',
      avatarUploadFailed: 'Failed to upload avatar',
      avatarUploadFormat: 'Uploading avatar images can only be in jpg/png format!',
      avatarUploadSize: 'The size of the uploaded avatar image cannot exceed 2MB!'
    },
    pwd: {
      oldPwd: 'Old password',
      newPwd: 'New password',
      confirmPwd: 'Confirm new password',
      inputNewPwd: 'Please enter a new password',
      inputOldPwd: 'Please enter your old password',
      pwdLenTips: 'Password cannot be less than 6 digits',
      inputPwdAgain: 'Please enter the password again',
      pwdNotEqual: 'The two passwords entered do not match!',
      modifySuccess: 'Successfully modified',
      modifyFailed: 'Modification failed'
    }
  },
  status: {
    examination: 'examination',
    practice: 'practice',
    questionnaire: 'questionnaire',
    interview: 'interview',
    complete: 'Statistics completed',
    markComplete: 'Corrected',
    todoMark: 'To be corrected',
    right: 'Right',
    wrong: 'Wrong',
    men: 'Men',
    women: 'Women'
  },
  media: {
    audio: {
      progress: 'Progress bar:',
      limit: 'Reached playback limit',
      playFailed: 'Failed to play voice',
      play: 'Play',
      pause: 'Pause',
      muted: 'Muted',
      notMuted: 'Play',
      transSpeed: 'Fast forward: x'
    },
    video: {
      playError: 'This video cannot be played at the moment. Please try again later'
    }
  },
  searchForm: {
    document: 'Documents',
    fileUnavailable: 'This document has no available link',
    q: 'Please input keyword',
    course: 'Course',
    exam: 'Examination',
    other: 'Other',
    searchSuccess: 'Search success',
    searchFailed: 'Search failed',
    searchResult: 'Find relevant results about',
    searchUnit: 'a', // 个
    searchHistory: 'Search history',
    allClear: 'Clear all',
    searchTips: "You haven't searched yet",
    searchTop: 'Top trending Searches'
  },
  becomeAPartner: {
    mainHeader: 'Become a Sigenergy Certified Installer',
    subheading: 'Join us to become a member of a community that values transparency, quality, growth and mutual support.'
  },
  becomeBPartner: {
    mainHeader: 'Become a Sigenergy Verified Distributor',
    subheading: 'Join us to become a member of a community that values transparency, quality, growth and mutual support.'
  },
  document: {
    documentType: 'Document type',
    filterTag: 'Filter tag',
    all: 'All',
    documentFile: 'Datasheets',
    videoFile: 'User Manual',
    voiceFile: 'Quick Install Guides',
    otherDocuments: 'Certificates',
    brochure: 'Brochure',
    flyer: 'Flyer',
    image: 'Image',
    video: 'Video',
    download: 'Download',
    center: 'Document center',
    emptyResult: 'No data available',
    plsSelectDocLang: 'Please select document language'

  },
  section: {
    filterTag: 'Product Category',
    trainingTag: 'Training Category',
    catalogue: 'Catalogue',
    total: 'Total',
    chapters: 'Chapters',
    title: 'Title',
    score: 'Score',
    points: 'Points',
    viewsNumber: 'Views ',
    people: 'People',
    videoDuration: ' duration',
    minutes: 'Minutes',
    collect: 'Collect',
    upvote: 'Upvote',
    startExamination: 'Start the examination',
    startDate: 'Start date',
    endDate: 'End date'
  },
  notification: {
    contentTitle: 'Notice title',
    first: 'Home',
    contentTitleDetail: 'Notice particulars',
    contentAbstract: 'Content',
    viewNum: 'Number of views',
    commentsNum: 'Number of comments',
    releaseDate: 'Release date'
  },
  problem: {
    contentTitle: 'Q&A title',
    first: 'Home',
    contentTitleDetail: 'details',
    contentAbstract: 'Abstract',
    viewNum: 'Number of views',
    commentsNum: 'Number of comments',
    updateDate: 'Update date',
    commentsTitle: 'Evaluation content',
    searchDefault: 'Q&A',
    commentContent: 'Add a comment',
    commentScore: 'Evaluation total',
    previouspage: 'previous',
    nextpage: 'next',
    commentUnit: 'times'
  },
  warranty: {
    contentTitle: 'Warranty clause',
    first: 'Home',
    contentTitleDetail: 'Details of warranty terms'
  },
  library: {
    quickLink: 'Quick Link',
    batchDownload: 'Batch Download',
    category: 'Category',
    subCategory: 'Sub-Categories',
    documentLanguage: 'Document Language',
    downloadTip: 'double click to download',
    filename: 'filename',
    maxLimit: 'Select the number of files, with a maximum of no more than {value}.',
    documentSearchKey: 'Please enter the document title keyword',
    allCategories:'All categories',
    currentCategory:'Search in current category: {value}',
    searchSuccess:'Search completed, search keywords:',
    searchFailed:'Search failed, please try again.',
    downloading: 'Downloading...',
    cancelDownload: 'Cancel',
    downloadCompleted: 'Download completed successfully!',
    downloadFailed: 'Download failed',
    downloadCancelled: 'Download cancelled'
  }
}


en.library.enquiry = {
  dialogTitle: 'Issue & Feedback',
  basicInfo: 'Basic Information',
  issueSection: 'Issue / Feedback',
  additionalInfo: 'Additional Information',
  privacy: 'Privacy Statement',
  yourName: 'Your name',
  yourCompany: 'Your company',
  yourRole: "What's your role",
  emailAddress: 'Email address',
  issueType: 'Issue Type',
  detailedDescription: 'Detailed Description',
  upload: 'Image / File Upload',
  uploadTip: 'Multiple files, size < {value}MB',
  privacyAgree: 'I agree that the platform may use this information for issue follow-up.',
  roleDistributor: 'Distributor',
  roleInstaller: 'Installer',
  roleGuests: 'Guests',
  issueFeatureInquiry: 'Feature Inquiry',
  issueBugReport: 'Bug Report',
  issueImprovement: 'Improvement Suggestion',
  issueOther: 'Other',
  btnSubmit: 'Submit',
  btnCancel: 'Cancel',
  msgSubmitSuccess: 'Submitted successfully',
  msgSubmitFailed: 'Submit failed',
  ruleRequired: 'Required',
  ruleInvalidEmail: 'Invalid email',
  ruleAgreeRequired: 'Please agree to the privacy statement',
  ruleFileTooLarge: 'File size must be < {value}MB'
};
en.chooseFile = 'Select Files'
en.select = 'Select'
en.library.enquiry.uploadDesc = 'Error code, interface screenshot, document, etc.'
en.library.enquiry.detailedDescriptionPlaceholder = 'Describe your issue, usage scenario, and expected improvement'
en.library.enquiry.uploadSuccess = 'Upload successful'
en.library.enquiry.uploadFailed = 'Upload failed'
export default en



// WEBPACK FOOTER //
// ./src/locales/lang/en/en.js